<template>
  <div class="sitemap-wrap py-3xl">
    <h2 class="px-2xl pb-2xl" v-text="localize('Catalog Index')"></h2>

    <div class="sitemap px-2xl">
        <ul class="index-list">
            <li class="pb-s" v-for="index_item in index_data" :key="index_item">
                <router-link :key="index_item"
                    :to="`product/${index_item}`"
                    class="text-gray-1">
                    <span v-text="index_item" class="text-gray-7"></span>
                </router-link>
            </li>
        </ul>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { fetchContent } from "@/utils";

export default {
  data() {
    return {
        index_data:[]
    };
  },
  async mounted() {
    this.resetPageLayout();
    this.initCatalogIndex();
    this.setPageReady(true);
  },
  methods: {
    ...mapActions(["resetPageLayout", "setPageReady"]),
    async initCatalogIndex() {
      let content = await fetchContent(
        "g",
        "catalog_index",
        this,
        this.$store.state,
        this.$store.commit,
        "SET_CATALOGINDEX",
        `https://api.mis-implants.com/api/catalogSiteIndexData`
      );
      console.log("sitemap content < ", content);
      this.index_data = content;
    }


  },
};
</script>

<style lang="stylus" scoped>
.index-list
  list-style-type none
  column-count 8
  display inline-block
  vertical-align top
  +below(1400px)
    column-count 4
  +below(1200px)
    column-count 3
  +below(768px)
    column-count 2
</style>

<style scoped>
  .pb-s
  {
      display: inline-block !important;
      vertical-align: top !important;
      width: 100%;
  }
</style>
